import { accessibilityStyle } from './accessibilityStyleCompNode'
import type { AccessibilityCssFeature } from './accessibilityStyle.types'
import { accessibilityDomApplier } from './accessibilityStyleDomApplier'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

export const accessibilityCssFeature: AccessibilityCssFeature = {
	featureName: 'accessibility',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { accessibilityStyle },
	intermediateNodes: {},
	dataMaps: ['document_data'],
	domApplier: accessibilityDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(accessibilityCssFeature)
}
export const editor: BindFeature = page
